/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The published signing key the identity provider currently trusts. Omitted after revocation.
 */
export type IdentityProviderConnectionActiveKey = {
  /**
   * ISO 8601 timestamp when the key became the signer.
   */
  activatedAt: Date;
  /**
   * JSON Web Key row ID.
   */
  id: string;
  /**
   * Key ID as published in the JWKS document.
   */
  kid: string;
};

/** @internal */
export const IdentityProviderConnectionActiveKey$inboundSchema: z.ZodMiniType<
  IdentityProviderConnectionActiveKey,
  unknown
> = z.pipe(
  z.object({
    activated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    kid: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "activated_at": "activatedAt",
    });
  }),
);

export function identityProviderConnectionActiveKeyFromJSON(
  jsonString: string,
): SafeParseResult<IdentityProviderConnectionActiveKey, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      IdentityProviderConnectionActiveKey$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IdentityProviderConnectionActiveKey' from JSON`,
  );
}
